<template>

    <Grid>

        <Column :span="[ 2, 3 ]">

            <Heading tag="h2" v-html="agileTeams.heading"/>

            <Button class="mt-12" :route="Route.Blog">
                {{ agileTeams.label }}
            </Button>

        </Column>

        <Column class="mt-16 md:mt-4" :span="[ 2, 2 ]" :push="[ 0, 1 ]">

            <ul class="agile-teams__list">

                <li v-for="(team, index) of agileTeams.team" :key="index" class="text-base font-body text-gray-600">
                    {{ team }}
                </li>

            </ul>

        </Column>

    </Grid>

</template>

<script lang="ts">

    import { defineComponent } from 'vue'
    import { useCms } from '../compositions/UseCms'
    import Grid from './Grid/Grid.vue'
    import Column from './Grid/Column.vue'
    import Heading from './Heading.vue'
    import Button from './Button.vue'
    import { Route } from '../enums/Route'

    export default defineComponent({
        name: 'AgileTeams',
        components: {
            Grid,
            Column,
            Heading,
            Button
        },
        setup() {

            const { agileTeams } = useCms()

            return {
                agileTeams,
                Route
            }

        }
    })

</script>

<style lang="scss">

    @include component(agile-teams) {

        @include part(list) {

            li {

                position: relative;
                padding-left: 10px;

            }

            li:before {

                position: absolute;
                top: 14px;
                left: 0px;
                width: 2px;
                height: 2px;
                background: #666666;
                border-radius: 2px;
                content: '';

            }

        }

    }

</style>
